<template>
  <div class="courseSuccess">
    <div class="img_box">
      <img @click="goForm" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/courseSuccess_btn_new.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'courseSuccess',
  data() {
    return {};
  },
  components:{},
  props: {
    qrcode: {
      type: String,
      default: ''
    },
  },
  methods: {
    closeRegisterAfter() {
      this.$emit('closeCourseSuccessAfter')
    },
    goForm(){
      this.closeRegisterAfter()
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
  .courseSuccess{
    width: 100%;
    height: 846px;
    background: url("https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/courseSuccess_bg_new.png");
    background-size: 100%;
    position: relative;
    .img_box{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      text-align: center;
      img{
        width: 394px;
        height: 109px;
      }
    }
  }
</style>
